export default __webpack_public_path__ + "static/media/img_4.ff90599f.JPG";